<template>
  <div id="company-information" class="kp-flat-card small-shadow">

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <div class="input-wrapper">
            <input v-floating-label id="companyName" name="companyName" v-model="companyName" type="text" class="form-control">
            <label for="companyName">Your Company name</label>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <div class="input-wrapper">
            <input v-floating-label id="shopUrl" name="shopUrl" v-model="shopUrl" type="text" class="form-control">
            <label for="shopUrl">Your Shop URL</label>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <div class="input-wrapper">
            <input v-floating-label id="shopCountry" name="shopCountry" v-model="shopCountry" type="text" class="form-control">
            <label for="shopCountry">Country of your shop</label>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <div class="input-wrapper">
            <input v-floating-label id="industry" name="industry" v-model="industry" type="text" class="form-control">
            <label for="industry">What kind of industry</label>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <div class="input-wrapper">
            <input v-floating-label id="yearlyTurnover" name="yearlyTurnover" v-model="yearlyTurnover" type="text" class="form-control">
            <label for="yearlyTurnover">Your average yearly turnover</label>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <div class="input-wrapper">
            <input v-floating-label id="averageTicketSize" name="averageTicketSize" v-model="averageTicketSize" type="text" class="form-control">
            <label for="averageTicketSize">Your average ticket size</label>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="field-switch-wrapper">
          <el-switch v-model="eCommerce"></el-switch>
          <p class="field-switch-label">Your enterprise operates</p>
          <p class="field-switch-value">E-Commerce</p>
        </div>
      </div>
      <div class="col-md-3">
        <div class="field-switch-wrapper">
          <el-switch v-model="salePoint"></el-switch>
          <p class="field-switch-label">Your enterprise operates</p>
          <p class="field-switch-value">Points of Sale</p>
        </div>
      </div>
      <div class="col-md-6">
        <el-select class="kp-select" :class="{filled: shopSystem}" v-model="shopSystem" filterable clearable placeholder="">
          <template #prefix>
            <label class="select-label">What kind of Shop System are you using?</label>
          </template>
          <el-option
            v-for="item in shopSystems"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
    </div>

    <div class="text-right mt-20">
      <button class="btn" @click="nextStep()">Configure Solutions</button>
    </div>

  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'company-information',
  computed: {
    ...mapFields({
      companyName: 'company.name',
      shopUrl: 'company.shopUrl',
      shopCountry: 'company.shopCountry',
      industry: 'company.industry',
      yearlyTurnover: 'company.yearlyTurnover',
      averageTicketSize: 'company.averageTicketSize',
      eCommerce: 'company.eCommerce',
      salePoint: 'company.salePoint',
      shopSystem: 'company.shopSystem'
    })
  },
  data() {
    return {
      shopSystems: [
        { value: 'magento', label: 'Magento' },
        { value: 'magento2', label: 'Magento 2' },
        { value: 'oscommerce', label: 'osCommerce' },
        { value: 'shopware', label: 'Shopware' },
        { value: 'veyton', label: 'Veyton' },
        { value: 'oxio', label: 'Oxio' },
        { value: 'jtl', label: 'JTLShop' },
        { value: 'modified', label: 'Modified' },
        { value: 'opencart', label: 'Opencart' },
        { value: 'prestashop', label: 'PrestaShop' },
        { value: 'spreecommerce', label: 'Spreecommerce' },
        { value: 'virtuemart', label: 'VirtueMart' },
        { value: 'woocommerce', label: 'WooCommerce' },
        { value: 'gambio', label: 'Gambio' },
        { value: 'epages', label: 'E.pages' },
        { value: 'ubercart', label: 'Übercart' },
        { value: 'shopify', label: 'Shopify' },
        { value: 'shopgate', label: 'Shopgate' },
        { value: 'cosmoshop', label: 'Cosmoshop' },
        { value: 'other', label: 'Other solutions' }
      ]
    }
  },
  methods: {
    nextStep() {
      this.$store.commit('changeRegisterStep', 2)
    }
  }
}
</script>
